import type { NiceBaseListIcons } from "@recursyve/nice-data-filter-kit";
import { NiceFilterGroupService } from "@recursyve/nice-data-filter-kit";

export enum FilterGroups {
    Accounts = "accounts",
    Applicants = "applicants",
    Clients = "clients",
    Courses = "courses",
    Distributors = "distributors",
    EnhancementCapsules = "enhancementCapsules",
    Members = "members",
    News = "news",
    Organisations = "organisations",
    Promotions = "promotions",
    PurchaseOrders = "purchaseOrders",
    Requests = "requests",
    Suppliers = "suppliers"
}

export class FilterGroupsService extends NiceFilterGroupService<FilterGroups> {
    public getFilterGroupIconClass(group: FilterGroups): NiceBaseListIcons | string {
        switch (group) {
            case FilterGroups.Accounts:
                return {
                    svgIcon: "streamline-regular:multiple-neutral-2"
                };
            case FilterGroups.Applicants:
                return {
                    svgIcon: "streamline-regular:single-neutral"
                };
            case FilterGroups.Clients:
                return {
                    svgIcon: "streamline-regular:multiple-neutral-2"
                };
            case FilterGroups.Courses:
                return {
                    svgIcon: "streamline-regular:book-library"
                };
            case FilterGroups.Distributors:
                return {
                    svgIcon: "streamline-regular:graduation-hat"
                };
            case FilterGroups.EnhancementCapsules:
                return {
                    svgIcon: "streamline-regular:book-library"
                };
            case FilterGroups.Members:
                return {
                    svgIcon: "streamline-regular:multiple-actions-laptop"
                };
            case FilterGroups.News:
                return {
                    svgIcon: "streamline-regular:newspaper-fold-1"
                };
            case FilterGroups.Organisations:
                return {
                    svgIcon: "streamline-regular:building-1"
                };
            case FilterGroups.Promotions:
                return {
                    svgIcon: "streamline-regular:tags"
                };
            case FilterGroups.PurchaseOrders:
                return {
                    svgIcon: "streamline-regular:shopping-cart"
                };
            case FilterGroups.Requests:
                return {
                    svgIcon: "streamline-regular:question-help-message"
                };
            case FilterGroups.Suppliers:
                return {
                    svgIcon: "streamline-regular:online-learning-ar-education"
                };
            default:
                return "";
        }
    }
}
